export default {
  backgroundColor: "rgba(81, 205, 160,0.2)",
};
